import { render, staticRenderFns } from "./ResponsiveIframeWrapper.vue?vue&type=template&id=12755174&"
import script from "./ResponsiveIframeWrapper.vue?vue&type=script&lang=js&"
export * from "./ResponsiveIframeWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports